var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "toggler-wrapper toggler-button",
    class: {
      'toggler-wrapper_disabled': _vm.disabled
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": _vm.modelValue
    },
    on: {
      "change": function ($event) {
        return _vm.emit('update:model-value', !_vm.modelValue);
      }
    }
  }), _vm._v(" "), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "toggler-slider"
  }, [_c('div', {
    staticClass: "toggler-knob"
  })]);
}]

export { render, staticRenderFns }